export const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 3a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM1 8.5a7.5 7.5 0 1113.3 4.72l4.5 4.5a1 1 0 11-1.42 1.42l-4.5-4.5A7.5 7.5 0 011 8.5z" fill="#6B7280"/>
  </svg>
); 